import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './contexts/AuthProvider';
import { AdminAuthProvider } from './contexts/AdminAuthProvider';
import { UploadQueueProvider } from './contexts/UploadQueueProvider';
import { ConfigProvider } from './contexts/ConfigProvider';
import { PrintSelectionProvider } from './contexts/PrintSelectionProvider';
import { ThemeProvider } from './contexts/ThemeProvider';
import { App } from './App';
import './styles/global.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          {/* Inside AuthProvider: a signed-in customer's theme comes from their profile. */}
          <ThemeProvider>
            <AdminAuthProvider>
              {/* Above the routes so a login redirect can't drop in-flight uploads. */}
              <UploadQueueProvider>
                <ConfigProvider>
                  <PrintSelectionProvider>
                    <App />
                  </PrintSelectionProvider>
                </ConfigProvider>
              </UploadQueueProvider>
            </AdminAuthProvider>
          </ThemeProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
